module.exports = __webpack_public_path__ + "img/wx.e6ace136.png";